import styled from "styled-components";

const ImageButton = styled("button")<{ bg: string }>`
  padding: 0.8rem 1.5rem;
  background: url(${(props) =>props.bg}) center no-repeat;
  background-size: contain;
  border: none;
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
`;

export default ImageButton;